export default "__VITE_ASSET__PO4lSx_q__"